import { manifests as collectionActionManifests } from './collection-action/manifests.js';
import { manifests as conditionManifests } from './conditions/manifests.js';
import { manifests as emptyRecycleBinEntityActionManifests } from './entity-action/empty-recycle-bin/manifests.js';
import { manifests as restoreFromRecycleBinEntityActionManifests } from './entity-action/restore-from-recycle-bin/manifests.js';
import { manifests as trashEntityActionManifests } from './entity-action/trash/manifests.js';
import { manifests as trashFolderEntityActionManifests } from './entity-action/trash-folder/manifests.js';
import { manifests as trashEntityBulkActionManifests } from './entity-bulk-action/bulk-trash/manifests.js';
import { manifests as treeManifests } from './tree/manifests.js';
import { manifests as workspaceContextManifests } from './workspace-context/manifests.js';

import type { UmbExtensionManifestKind } from '@umbraco-cms/backoffice/extension-registry';

export const manifests: Array<UmbExtensionManifest | UmbExtensionManifestKind> = [
	...collectionActionManifests,
	...conditionManifests,
	...emptyRecycleBinEntityActionManifests,
	...restoreFromRecycleBinEntityActionManifests,
	...trashEntityActionManifests,
	...trashFolderEntityActionManifests,
	...trashEntityBulkActionManifests,
	...treeManifests,
	...workspaceContextManifests,
];
